import { render } from "./FeedBack.vue?vue&type=template&id=4fe7bee8&scoped=true"
import script from "./FeedBack.vue?vue&type=script&lang=js"
export * from "./FeedBack.vue?vue&type=script&lang=js"

import "./FeedBack.vue?vue&type=style&index=0&id=4fe7bee8&lang=less&scoped=true"

import exportComponent from "/data/web/pay/agpay/antpay-h5-hengban/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe7bee8"]])

export default __exports__